import React, { useEffect, useState } from "react";
import { observer } from "mobx-react";
import { Box, useTheme, useMediaQuery, CircularProgress, Button } from "@mui/material";
import useStore from "../../helpers/useStore";
import { PatientsContext } from "../../stores/Patients/patients.provider";
import { useMasterTables } from "../../stores/MasterTables";
import { TopLevelPaper } from "../../themes/StyledComponents";
import PatientPage from "../PatientDataEntryForm/PatientPage";
import PatientOverview from "../PatientOverview/PatientOverview";
import { PatientNotesAndRecords } from "../PatientOverview/PatientNotesAndRecords";
import { usePatientRoute } from "../../routes/usePatientRoute";
import PatientColumnTabs from "./PatientColumnTabs";
import { usePatient } from "../../stores/Patients/patient.queries";
import { set } from "mobx";
import { useApi } from "../../api/ApiProvider";

const constructSearchPath = (params: any) => {
  return "/patient"; // Placeholder implementation
};

const PatientColumn = observer(() => {
  const PatientsStore = useStore(PatientsContext);
  const { data: masterTablesData } = useMasterTables();
  const { patients: patientsApi } = useApi();
    const [open, setOpen] = useState(false);
     const [rxopen, setRxOpen] = useState(false);

  const {
    selectedPatientId,
    openPatients,
    setSelectedPatientId,
    getSelectedPatientparams,
    addToTabs,
  } = PatientsStore;

  // ** this is the main negotiation of what to do when a patient is selected or opened
  const { data: patient, isLoading: fetchingPatient } = usePatient(selectedPatientId!);
  useEffect(() => {
    if (patient) {
      addToTabs(patient); // add only after render to avoid mutating observables during render
    }
  }, [patient, addToTabs]);

  return (
    <>
     {/* <Button onClick={() => setOpen(!open)} variant="contained">Patient Button</Button>
          {open && <PatientTable />}
           <Button onClick={() => setRxOpen(!rxopen)} variant="contained">RX Button</Button>
          {rxopen && <RxsTable />} */}
      {/* This is the grid for the left side */}
      <PatientColumnTabs selectedPatientId={selectedPatientId} openPatients={openPatients} />
      <TopLevelPaper
        sx={{
          display: "flex",
          flexDirection: "column",
          flexWrap: "nowrap",
          height: "100%",
        }}
      >
        {!selectedPatientId && <PatientPage isEditing={false} />}
        {selectedPatientId && (
          <>
            <PatientOverview patientId={selectedPatientId!} linkOut="calendar" />
            <PatientNotesAndRecords patientId={selectedPatientId} />
          </>
        )}
      </TopLevelPaper>
    </>
  );
});

export default PatientColumn;
